// extracted by mini-css-extract-plugin
export default {"wrap":"achievements_wrap__dIYEE","resurrected":"achievements_resurrected__9OxL7","finished":"achievements_finished__wZquJ"};